import { render, staticRenderFns } from "./index1.vue?vue&type=template&id=5159c6db&scoped=true"
import script from "./index1.vue?vue&type=script&lang=js"
export * from "./index1.vue?vue&type=script&lang=js"
import style0 from "./index1.vue?vue&type=style&index=0&id=5159c6db&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5159c6db",
  null
  
)

export default component.exports